import React from 'react';
import Header from '../components/Header';

import '@fontsource/gloock'
import '@fontsource-variable/league-spartan'

export default (props: any) => <Header {...props} />;